import * as z from 'zod'
import { McIssueListItem } from '../McIssueEntity.js'
import { GetApiContract, PutApiContract } from './ApiContract.js'
import { schemaBoolish } from './zodUtils.js'

export interface GetMcIssuesListRequest extends GetApiContract {
    Response: Array<McIssueListItem>
}

export const putMcIssuesSchema = z.object({
    archived: schemaBoolish,
    isConvertible: schemaBoolish.nullish(),
})

export interface PutMcIssuesRequest extends PutApiContract {
    Body: z.infer<typeof putMcIssuesSchema>
    Response: {
        id: string
        instrumentHistoryId: string
        archivedAt: string
        isConvertible: 0 | 1
    }
}
